import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/calendar/mocker'
import _ from 'lodash'

export default {
  receivedcalendar (year) {
    if (isMock) return generator(mocker.calendar(year))
    return instance().get(endpoint + '/calendar/' + year)
  },
  receivedcalendarTab1 (year) {
    if (isMock) return generator(mocker.calendarTab1(year))
    return instance().get(endpoint + '/calendar/leave/' + year)
  },
  receivedcalendarTab2 (year) {
    if (isMock) return generator(mocker.calendarTab2(year))
    return instance().get(endpoint + '/calendar/appointment/' + year)
  },
  receivedcalendarTab3 (year) {
    if (isMock) return generator(mocker.calendarTab3(year))
    return instance().get(endpoint + '/calendar/training/' + year)
  },
  receivedcalendarTab4 (year) {
    if (isMock) return generator(mocker.calendarTab4(year))
    return instance().get(endpoint + '/calendar/todolist/' + year)
  },
  receivedHoliday (year) {
    if (isMock) return generator(mocker.holiday(year))
    return instance().get(endpoint + '/calendar/holiday/' + year)
  },
  postCalendarTab4Checked (sendParams) {
    if (isMock) return generator(mocker.postCalendarTab4Checked())
    let params = _.padStart(sendParams.date, 2, '0') + '' + _.padStart(sendParams.month, 2, '0') + '' + sendParams.year + '/' + sendParams.numseq
    return instance().post(endpoint + '/calendar/saveTodolistChecked/' + params)
  },
  postCalendarTab4 (sendParams) {
    if (isMock) return generator(mocker.postCalendarTab4())
    return instance().post(endpoint + '/calendar/saveTodolist', sendParams)
  },
  deleteCalendarTab4 (sendParams) {
    if (isMock) return generator(mocker.deleteCalendarTab4())
    let params = _.padStart(sendParams.date, 2, '0') + '' + _.padStart(sendParams.month, 2, '0') + '' + sendParams.year + '/' + sendParams.numseq
    return instance().delete(endpoint + '/calendar/deleteTodolist/' + params)
  }
}



// WEBPACK FOOTER //
// ./src/api/calendar/index.js